"use client";

import { storyblokEditable } from "@storyblok/react/rsc";
import { track } from "@vercel/analytics";
import Image from "next/image";
import Link from "next/link";

import type { OfferTeaserStoryblok } from "@/component-types-sb";
import { isWithinStoryblokSchedule } from "@/lib/storyblok/utils";
import imageLoader from "@/lib/utils/imageLoader";

type OfferTeaserProps = {
  blok: OfferTeaserStoryblok;
};

const OfferTeaser = ({ blok }: OfferTeaserProps) => {
  const shouldRender = isWithinStoryblokSchedule(
    blok.publishDate,
    blok.expireDate
  );

  if (!shouldRender) return null;

  return (
    <Link
      href={blok.link?.cached_url || "#"}
      aria-label="Spezielle Angebote entdecken"
      {...storyblokEditable(blok)}
      className="block pt-8"
    >
      <Image
        className="object-contain w-full h-auto"
        loader={imageLoader}
        src={blok.image?.filename || ""}
        width={1628}
        height={200}
        alt={blok.image?.alt || ""}
        onClick={() => {
          track("Offer click", { offer: blok.link.story.name });
        }}
      />
      <p className="py-4 text-xs text-gray-500 text-center">{blok.text}</p>
    </Link>
  );
};

export default OfferTeaser;
